import styled from 'styled-components';
import type {TicketSla} from '../types/ticket';

export const SlaBadgeBase = styled.span<{$bg?: string; $border?: string; $color: string}>`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font: ${p => p.theme.ticketing.font.body3};
	color: ${p => p.$color};
	${p => p.$bg && `background: ${p.$bg};`}
	${p => p.$bg && `border-radius: ${p.theme.ticketing.radius.full};`}
	${p => p.$bg && 'padding: 2px 8px;'}
	${p => p.$bg && 'font-weight: 500;'}
	${p => p.$border && `border: 1px solid ${p.$border};`}
`;

export const SlaIcon = styled.svg`
	height: 12px;
	width: 12px;
`;

export function formatElapsedTime(seconds: number): string {
	const hours = Math.floor(seconds / 3600);
	if (hours >= 24) {
		const days = Math.floor(hours / 24);
		const remainingHours = hours % 24;
		return `${days}d ${remainingHours}h`;
	}
	const minutes = Math.floor((seconds % 3600) / 60);
	return `${hours}h ${minutes}m`;
}

export function SLABadge({ticket}: {ticket: {sla: TicketSla | null | undefined}}) {
	const {sla} = ticket;

	if (!sla) return null;

	if (sla.paused) {
		return (
			<SlaBadgeBase $bg="#f1f5f9" $color="#94a3b8">
				<SlaIcon fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
					<circle cx="12" cy="12" r="10" />
					<path d="M10 9l2 2 4-4" />
				</SlaIcon>
				paused
			</SlaBadgeBase>
		);
	}

	if (sla.breached) {
		return (
			<SlaBadgeBase $bg="#fef2f2" $border="#fecaca" $color="#dc2626">
				<SlaIcon fill="currentColor" viewBox="0 0 20 20">
					<circle cx="10" cy="10" r="10" />
				</SlaIcon>
				breached
			</SlaBadgeBase>
		);
	}

	const ratio = sla.thresholdSeconds > 0 ? sla.elapsedSeconds / sla.thresholdSeconds : 0;

	if (ratio >= 0.8) {
		return (
			<SlaBadgeBase $bg="#fff7ed" $border="#fed7aa" $color="#ea580c">
				<SlaIcon fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
					<circle cx="12" cy="12" r="10" />
					<path d="M12 6v6l4 2" />
				</SlaIcon>
				{formatElapsedTime(sla.elapsedSeconds)}
			</SlaBadgeBase>
		);
	}

	return (
		<SlaBadgeBase $color="#0d9488">
			<SlaIcon fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
				<circle cx="12" cy="12" r="10" />
				<path d="M12 6v6l4 2" />
			</SlaIcon>
			{formatElapsedTime(sla.elapsedSeconds)}
		</SlaBadgeBase>
	);
}
